import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const CenteredLoader = () => (
    <Box
        sx={{
            height: '100vh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
    >
        <CircularProgress />
    </Box>
);

export default CenteredLoader;
